<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import PaymentsTableTab from '@/components/payments/PaymentsTableTab.vue';
import type { PaymentsTabId } from '@/composables/usePayments';
import { CLEARED_ONLY_STATUSES } from '@/services/paymentStatus';

defineProps<{
    tabId?: PaymentsTabId;
}>();
</script>

<template>
    <PaymentsTableTab
        :base-statuses="CLEARED_ONLY_STATUSES"
        empty-description="No deposits match your current filters."
        process-date-header="Cleared Date"
    />
</template>
